// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPhone = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path
                fill="currentColor"
                d="M13.9781253,10.5821923 L13.3423831,13.338442 C13.2530787,13.7280904 12.9106251,14.0007068 12.5094928,14.0007068 C5.61093742,14.000161 0,8.38922322 0,1.49039542 C0,1.08953595 0.272589684,0.746645091 0.662265658,0.657777903 L3.41851574,0.0220357156 C3.81992179,-0.0709871077 4.23007804,0.137372134 4.39687508,0.517505167 L5.66890645,3.48430121 C5.81760186,3.83375513 5.717305,4.24090314 5.42335969,4.48098123 L3.95117188,5.66305184 C4.88031238,7.55578625 6.41921902,9.09469247 8.3125,10.02438 L9.51781297,8.55328655 C9.75537515,8.25852096 10.1655865,8.15652847 10.5150396,8.30787623 L13.4818364,9.57963431 C13.838672,9.76734888 14.0710931,10.1829734 13.9781253,10.5821923 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default IconPhone;
